import React from 'react';
import {
    Button,
    Grid,
    SvgIcon,
    Typography,
    LinearProgress
} from '@mui/material';
import { Link } from 'react-router-dom-v5-compat';
import { useSubscription } from '@/hooks/useSubscription';
import { setPlanIcon } from '@/util';

import useStyles from './styles';

const SubscriptionCounter = () => {
    const { components, loading, productId } = useSubscription() || {};

    const { amountUsed, maxAmount, limited } = components?.document || {};

    const ninetyPlusUsed = amountUsed / maxAmount >= 0.9;

    const classes = useStyles({
        percentFilled: limited ? (amountUsed / maxAmount) * 100 || 3 : 0,
        ninetyPlusUsed
    });

    if (loading || !limited || productId === 'visitor') return null;

    return (
        <Grid item container className={classes.counterBoxContainer}>
            <Grid item container alignItems="center" className={classes.topRow}>
                <SvgIcon
                    className={classes.planIcon}
                    component={setPlanIcon(productId)}
                />
                <Typography
                    variant="body2"
                    color="textSecondary"
                    display="inline"
                    className={classes.topRowText}
                >
                    <span className={classes.capsText}>{productId}</span> Plan (
                    {maxAmount} doc
                    {maxAmount > 1 && 's'}/mo)
                </Typography>
            </Grid>
            <Grid item container justifyContent="space-between">
                <Grid item>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        display="inline"
                        className={classes.boldText}
                    >
                        Documents
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        display="inline"
                        align="right"
                        className={classes.boldText}
                    >
                        {amountUsed}/{maxAmount}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item className={classes.itemsRemainingBar}>
                <LinearProgress
                    value={(amountUsed / maxAmount) * 100 || (limited ? 3 : 0)}
                    variant="determinate"
                    classes={{
                        root: classes.progressBarRoot,
                        bar: classes.progressBarInner
                    }}
                />
            </Grid>
            <Button
                component={Link}
                to="/settings/subscription"
                fullWidth
                variant="contained"
                color="grey"
                className={classes.upgradeButton}
                role="link"
            >
                Upgrade Plan
            </Button>
        </Grid>
    );
};

export default SubscriptionCounter;
